<template>
	<div>
		
		<layout>

			<template v-slot:title> 
				PAQUETERÍAS
			</template>

			<template v-slot:subtitle> 
				PAQUETERÍAS
			</template>


			<template v-slot:content>

				<div class="pa-sm-10">
					
					<v-container>

						<v-row>
							<v-col offset-lg="2" lg="8" offset="0" cols="12">

								<v-row>

									<v-col lg="4" v-for="pack in packages">
										<v-card elevation="0" light outlined style="background: #fafafa;">
											
											<div class="text-center pa-5">
												<img :src="backend+'../storage/app/'+pack.logo">
												<p class="mb-0">
													Estado: 

													<b class="red--text" v-if="pack.status == 'a'">Activo</b>
													<span style="color:gray" v-else>Inactivo</span>

												</p>
											</div>

									  </v-card>
									</v-col>

								</v-row>

							</v-col>
						</v-row>

					</v-container>

				</div>

		  </template>

		</layout>

	</div>
</template>


<script>
	
	import Layout from './../../layout/Layout'
	import PackageService from '@/shared/services/PackageService'


	export default
	{

		data() {
			return {
        packages:null
			}
		},

		components: {
			Layout,
		},

		created() {
			this.getPackages()
		},

		methods: {

			async getPackages()
			{
				const resp = await PackageService.get()
				this.packages = resp.data
			}

		}

	}

</script>